<template>
  <a-modal
      title="群发列表"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :width="800"
    >
      <a-card :bordered="false" v-if="currentRobotId">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="12" :sm="24">
                <a-form-item label="搜索条件">
                  <a-select placeholder="请选择" allowClear>
                    <a-select-option value="1">订单号</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item label="搜索关键字">
                  <a-input placeholder="请输入" />
                </a-form-item>
              </a-col>
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span
                  class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                >
                  <a-button type="primary">清空列表</a-button>
                  <a-button type="primary" style="margin-left: 8px">查询</a-button>
                  <a-button style="margin-left: 8px">重置</a-button>
                  <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </a-card>
    </a-modal>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      currentRobotId: null,
      advanced: false,
    }
  },
  methods: {
    show(robot_id) {
      this.currentRobotId = robot_id
      this.visible = true
    },
    handleOk(e) {
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel(e) {
      this.visible = false;
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
  },
}
</script>
